import React from 'react';
import './FounderNote.css';

const FounderNote = () => {
  return (
    <section className="founder-note-section section">
      <h2 className="section-title">Founder's Note</h2>
      
      <div className="founder-note-container">
        <div className="founder-image">
          <img src="/images/team/rg.png" alt="Mr. Ramesh Gupta" className="founder-image-photo" />
        </div>
        
        <div className="founder-message">
          <blockquote className="founder-quote">
            <p>
              "At Global Business Combine, we believe that quality is not just a promise—it is our commitment. 
              When I started this journey, my vision was simple: to create tools that industries can rely on 
              without compromise. Over the years, this vision has evolved into a mission that every team member 
              at GBC lives by. We focus on delivering not just products but solutions that empower our customers 
              to be at their best.
            </p>
            
            <p>
              We understand the challenges that industries face in maintaining precision and efficiency, 
              and it is our privilege to provide the tools that help overcome these hurdles. Our focus on 
              continuous improvement, ethical practices, and customer satisfaction drives us every day. 
              I invite you to explore our product range and experience the GBC difference."
            </p>
            
            <footer className="founder-signature">
              <span className="founder-name">Mr. Ramesh Gupta</span>
              <span className="founder-title">Founder & Chairman</span>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default FounderNote;
